import React, { Component } from 'preact/compat';

import Loader from '../components/Loader/Loader';

export default function importComponent(importFunction) {
  return class ComponentImporter extends Component {
    async componentWillMount() {
      this.setState({ component: await importFunction() });
    }

    render() {
      const ImportedComponent = this.state.component;

      return (
        <Loader loaded={Boolean(this.state.component)}>
          <ImportedComponent {...this.props} />
        </Loader>
      );
    }
  };
}
